export default __webpack_public_path__ + "static/soehne-web-leicht-06dee1da6ec4ba1e6fa3d96409ebcf9e.woff";